import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Utils } from 'src/app/core/resources/utils';
import { CargoService } from 'src/app/core/services/cargo.service';
import { CargoDetailService } from '../cargo-detail/cargo-detail.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';

@Component({
  selector: 'app-global-tracking',
  templateUrl: './global-tracking.component.html',
  styleUrls: ['./global-tracking.component.scss']
})
export class GlobalTrackingComponent {

  public cargos: Cargo[];
  public cargoSelected: Cargo = null;
  private filters: string = '';
  private selectionRequestId = 0;
  public loadingCargos: boolean = true;
  public loadingMap: boolean = false;

  constructor(
    public utils: Utils,
    private cargoService: CargoService,
    private cargoDetailService: CargoDetailService,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
  ) { }

  getInRouteCargos() {
    this.selectionRequestId++;
    this.cargoSelected = null;
    this.loadingCargos = true;
    this.spinner.show();
    if (this.filters.charAt(0) === '&') this.filters = this.filters.substring(1);
    this.cargoService.cargoMapPositions(this.filters).subscribe(
      (response) => {
        this.spinner.hide();
        this.loadingCargos = false;
        if (response) {
          this.cargos = this.sortCargos(response.results);
          if (this.cargos.length === 1) this.onSelectCargo(this.cargos[0]);
        } else {
          this.cargos = [];
        }
      },
      (error) => {
        this.spinner.hide();
        this.loadingCargos = false;
        console.error(error);
        this.cargos = [];
      }
    );
  }

  sortCargos(cargos: Cargo[]) {
    return cargos.sort((a, b) => {
      const hasLicensePlateA = a.hasOwnProperty('licensePlate');
      const hasLicensePlateB = b.hasOwnProperty('licensePlate');

      if (hasLicensePlateA && hasLicensePlateB) {
        const nameA = a.licensePlate.toLowerCase();
        const nameB = b.licensePlate.toLowerCase();
        return nameA.localeCompare(nameB);
      }
      else if (hasLicensePlateA) return -1;
      else if (hasLicensePlateB) return 1;
      else return 0;
    });
  }

  public onSelectCargo(cargo: Cargo): void {
    const requestId = ++this.selectionRequestId;
    if (!cargo) {
      this.cargoSelected = null;
      return;
    }

    this.spinner.show();
    this.cargoDetailService.detailCargo(cargo.id).subscribe(
      (cargoDetail: Cargo) => {
        if (requestId !== this.selectionRequestId) return;
        this.spinner.hide();
        this.cargoSelected = cargoDetail && cargoDetail.id ? cargoDetail : null;
        if (!this.cargoSelected)
          this.snackBarService.openSnackBar('No fue posible obtener el detalle del servicio', undefined, 'error');
      },
      (error) => {
        if (requestId !== this.selectionRequestId) return;
        this.spinner.hide();
        this.cargoSelected = null;
        this.snackBarService.openSnackBar('No fue posible obtener el detalle del servicio', undefined, 'error');
        console.error(error);
      }
    );
  }

  refreshList($event: string) {
    this.filters = $event;
    this.getInRouteCargos();
  }
}
